import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

if (environment.PRODUCTION.toString().toLowerCase() === "true") {
  enableProdMode();
  window.console.log = function () {
    // This is intentional
  };
}

function mostrarCortina(): void {
  fetch('/cortina.html')
    .then(response => response.text())
    .then(html => {
      document.open();
      document.write(html);
      document.close();
    })
    .catch(err => console.error('Error al cargar la página de cortina:', err));
}

const enableMaintenanceCurtain = environment.ENABLE_MAINTENANCE_CURTAIN?.toString().toLowerCase() === 'true';
const enableMaintenanceCurtainVip = environment.ENABLE_MAINTENANCE_CURTAIN_VIP?.toString().toLowerCase() === 'true';
// Detecta VIP por localStorage (visitas recurrentes) o por URL de entrada VIP (primera visita, antes de que se setee 'okt')
const esVip = localStorage.getItem('okt') === 'true' || window.location.pathname.includes('/externo/token');

if (enableMaintenanceCurtain || (enableMaintenanceCurtainVip && esVip)) {
  mostrarCortina();
} else {
  // Flujo normal de la aplicación
  // platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  //   .catch(err => console.error(err));

  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}
